<template>
  <div class="col-3">

    <div class="sidebar sidebar-content sidebar-right mb-4 ms-auto" v-if="bidder">
      <h2 class="display-3 mb-0"> Winnaar
        <div class="text-uppercase mb-5">Jan Joost van Gangelen</div>
      </h2>

      <p class="option__name">Geboden</p>
      <p class="price mb-5"> &euro; 0,20 </p>

      <p class="option__name">Totaal kosten</p>
      <p class="price">&euro; 2,00</p>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    bidder: {
      type: Object,
      default: null,
    }

  },
  methods: {
    getMaxPricePerUnit()
    {
      return parseFloat(this.item.unit) * 100;
    }

  }
}
</script>
